import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MealName, MealItem, Data } from './services/data';
import { MatStepper } from '@angular/material/stepper';
import * as moment from 'moment';
import { Router, ActivatedRoute } from '@angular/router';
import { timeToTime } from './services/util';
import { debounceTime, switchMap, } from 'rxjs/operators';
import { MatAutocomplete } from '@angular/material';
var AddMealComponent = /** @class */ (function () {
    function AddMealComponent(builder, data, router, route) {
        this.builder = builder;
        this.data = data;
        this.router = router;
        this.route = route;
        this.mealName = MealName.Breakfast;
        this.mealDate = moment();
        this.items = [];
        this.mealNames = Object.getOwnPropertyNames(MealName).map(function (name) { return MealName[name]; });
        this.columnsToDisplay = ['name', 'calories', 'carbs', 'fat', 'protein', 'delete'];
        this.confirmColumns = ['name', 'calories', 'carbs', 'fat', 'protein'];
        this.loading = true;
    }
    AddMealComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var desc, id, meal, day, e_1, day, name_1, e_2;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.basicInfo = this.builder.group({
                            date: this.mealDate,
                            time: this.mealDate.format('HH:mm'),
                            name: this.mealName,
                        });
                        this.basicInfo.valueChanges.subscribe(function (change) {
                            _this.mealName = change.name;
                            var mealDate = change.date;
                            var time = timeToTime(change.time);
                            mealDate.hours(time.hours);
                            mealDate.minutes(time.minutes);
                            _this.mealDate = mealDate;
                        });
                        this.addFood = this.builder.group({
                            desc: '',
                            calories: null,
                            carbs: null,
                            fat: null,
                            protein: null,
                        });
                        desc = this.addFood.get('desc');
                        this.recommendedFoods = desc.valueChanges.pipe(debounceTime(300), switchMap(function (v, i) { return _this.getRecommendations(v); }));
                        this.autoComplete.optionSelected.subscribe(function (value) {
                            _this.data.mealItems.get(value.option.value).then(function (food) {
                                _this.addFood.setValue({
                                    desc: "" + food.name,
                                    calories: food.calories,
                                    carbs: food.carbs,
                                    fat: food.fat,
                                    protein: food.protein,
                                }, { emitEvent: false, onlySelf: true });
                            });
                        });
                        id = this.route.snapshot.paramMap.get('id');
                        if (!id) return [3 /*break*/, 6];
                        console.log('getting info from db');
                        meal = void 0;
                        day = void 0;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.data.getMeal(id)];
                    case 2:
                        meal = _a.sent();
                        console.log('got meal', meal);
                        return [4 /*yield*/, this.data.days.get(meal.dayId)];
                    case 3:
                        day = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        console.error('error getting info from db', e_1);
                        return [3 /*break*/, 5];
                    case 5:
                        this.mealDate = moment(day.date);
                        this.mealDate.hours(meal.time.hours);
                        this.mealDate.minutes(meal.time.minutes);
                        this.setBasicInfo(meal.name);
                        this.items = meal.contents;
                        _a.label = 6;
                    case 6:
                        _a.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, this.data.getTodaysEntries()];
                    case 7:
                        day = _a.sent();
                        name_1 = this.getNextMealFrom(day.meals);
                        this.basicInfo.setValue({ date: this.mealDate,
                            time: this.mealDate.format('HH:mm'),
                            name: name_1,
                        });
                        return [3 /*break*/, 9];
                    case 8:
                        e_2 = _a.sent();
                        console.error(e_2);
                        return [3 /*break*/, 9];
                    case 9:
                        this.loading = false;
                        console.log('ngOnInit end');
                        return [2 /*return*/];
                }
            });
        });
    };
    AddMealComponent.prototype.getNextMealFrom = function (meals) {
        var reducer = { breakfast: false, lunch: false, dinner: false, tea: false };
        var _a = meals.reduce(function (acc, item) {
            switch (item.name) {
                case MealName.Breakfast:
                    acc.breakfast = true;
                    break;
                case MealName.Lunch:
                    acc.lunch = true;
                    break;
                case MealName.Tea:
                    acc.tea = true;
                    break;
                case MealName.Dinner:
                    acc.dinner = true;
                    break;
            }
            return acc;
        }, reducer), breakfast = _a.breakfast, lunch = _a.lunch, dinner = _a.dinner, tea = _a.tea;
        if (!breakfast) {
            return MealName.Breakfast;
        }
        else if (!lunch) {
            return MealName.Lunch;
        }
        else if (!tea) {
            return MealName.Tea;
        }
        else if (!dinner) {
            return MealName.Dinner;
        }
        else {
            return MealName.Snack;
        }
    };
    AddMealComponent.prototype.setBasicInfo = function (name) {
        this.basicInfo.setValue({
            date: this.mealDate,
            time: this.mealDate.format('HH:mm'),
            name: name
        });
    };
    AddMealComponent.prototype.getRecommendations = function (term) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof term !== 'string') {
                            return [2 /*return*/, []];
                        }
                        return [4 /*yield*/, this.data.findFood(term)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.reduce(function (acc, v) {
                                if (acc.known.has(v.name)) {
                                    return acc;
                                }
                                acc.known.add(v.name);
                                acc.ret.push(v);
                                return acc;
                            }, { ret: [], known: new Set() }).ret];
                }
            });
        });
    };
    AddMealComponent.prototype.addMealItem = function () {
        var values = this.addFood.value;
        this.items = this.items.concat([new MealItem(values.desc, values.calories, values.carbs, values.protein, values.fat)
        ]);
        this.addFood.reset({ desc: '', calories: null, carbs: null, fat: null, protein: null });
    };
    AddMealComponent.prototype.removeItem = function (idx) {
        this.items = this.items.filter(function (_, i) { return i !== idx; });
    };
    AddMealComponent.prototype.saveMeal = function () {
        var _this = this;
        var id = this.route.snapshot.paramMap.get('id');
        if (id) {
            this.data.updateMeal(id, this.mealDate, this.mealName, this.items).then(function () {
                _this.router.navigate(['/']);
            });
        }
        else {
            this.data.addMeal(this.mealDate, this.mealName, this.items).then(function () {
                _this.router.navigate(['/']);
            });
        }
    };
    Object.defineProperty(AddMealComponent.prototype, "calories", {
        get: function () {
            return this.items.reduce(function (a, c) { return a + c.calories || 0; }, 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddMealComponent.prototype, "carbs", {
        get: function () {
            return this.items.reduce(function (a, c) { return a + c.carbs || 0; }, 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddMealComponent.prototype, "fat", {
        get: function () {
            return this.items.reduce(function (a, c) { return a + c.fat || 0; }, 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddMealComponent.prototype, "protein", {
        get: function () {
            return this.items.reduce(function (a, c) { return a + c.protein || 0; }, 0);
        },
        enumerable: true,
        configurable: true
    });
    AddMealComponent.prototype.calcCals = function () {
        var values = this.addFood.value;
        var fromCarbs = values.carbs * 4;
        var fromProt = values.protein * 4;
        var fromFat = values.fat * 9;
        values.calories = fromCarbs + fromProt + fromFat;
        this.addFood.setValue(values);
    };
    return AddMealComponent;
}());
export { AddMealComponent };
